import { Field } from 'redux-form';

import {
  TextField,
  SelectField,
  CheckBox,
  RadioButton,
  DatePicker,
  TextArea,
  normalizeDecimal,
  normalizeInteger,
  normalizeDate
} from 'common/components/forms';

const FormMetaData = (props) => {
  const { c7Form, customerMetaData } = props;
  if (c7Form.metaDataAttributes.length === 0) {
    return null;
  }
  if (!customerMetaData.data) {
    return null;
  }
  const metaDataIdArray = Object.keys(customerMetaData.data);
  const metaDataArray = metaDataIdArray.map((id) => customerMetaData.data[id]);
  return (
    <>
      {c7Form.metaDataAttributes.map((metaDataCode) => {
        const metaDataElement = metaDataArray.find(
          (metaData) => metaData.code === metaDataCode
        );
        if (!metaDataElement) {
          return null;
        }
        return (
          <div key={metaDataElement.id}>
            {renderField(metaDataElement, c7Form.code)}
          </div>
        );
      })}
    </>
  );
};

const renderField = (metaData, code) => {
  switch (metaData.dataType) {
    case 'Number': {
      return (
        <Field
          name={`metaData-${code}-${metaData.id}`}
          component={TextField}
          label={metaData.title}
          normalize={normalizeDecimal}
          required={metaData.isRequired}
        />
      );
    }
    case 'Integer': {
      return (
        <Field
          name={`metaData-${code}-${metaData.id}`}
          component={TextField}
          label={metaData.title}
          normalize={normalizeInteger}
          required={metaData.isRequired}
        />
      );
    }
    case 'String': {
      return (
        <Field
          name={`metaData-${code}-${metaData.id}`}
          component={TextField}
          label={metaData.title}
          required={metaData.isRequired}
        />
      );
    }
    case 'Checkbox': {
      return (
        <>
          {metaData.title}
          {metaData.options.map((option) => (
            <Field
              name={`metaData-${code}-${metaData.id}-${option}`}
              component={CheckBox}
              type="checkbox"
              value={option}
              label={option}
              key={option}
              required={metaData.isRequired}
            />
          ))}
        </>
      );
    }
    case 'Radio': {
      return (
        <>
          {metaData.title}
          {metaData.options.map((option) => (
            <Field
              name={`metaData-${code}-${metaData.id}`}
              component={RadioButton}
              type="radio"
              value={option}
              label={option}
              key={option}
              required={metaData.isRequired}
            />
          ))}
        </>
      );
    }
    case 'Select': {
      return (
        <Field
          name={`metaData-${code}-${metaData.id}`}
          component={SelectField}
          label={metaData.title}
          optionArray={dropDownArray(metaData.options)}
          required={metaData.isRequired}
        />
      );
    }
    case 'Date Picker': {
      return (
        <Field
          name={`metaData-${code}-${metaData.id}`}
          component={DatePicker}
          label={metaData.title}
          normalize={normalizeDate}
          required={metaData.isRequired}
        />
      );
    }
    case 'TextArea': {
      return (
        <Field
          name={`metaData-${code}-${metaData.id}`}
          component={TextArea}
          label={metaData.title}
          rows={3}
          required={metaData.isRequired}
        />
      );
    }
    case 'True / False': {
      return (
        <>
          {metaData.title}
          <Field
            name={`metaData-${code}-${metaData.id}`}
            component={RadioButton}
            type="radio"
            value="True"
            label="True"
            required={metaData.isRequired}
          />
          <Field
            name={`metaData-${code}-${metaData.id}`}
            component={RadioButton}
            type="radio"
            value="False"
            label="False"
            required={metaData.isRequired}
          />
        </>
      );
    }
    case 'Yes / No': {
      return (
        <>
          {metaData.title}
          <Field
            name={`metaData-${code}-${metaData.id}`}
            component={RadioButton}
            type="radio"
            value="Yes"
            label="Yes"
            required={metaData.isRequired}
          />
          <Field
            name={`metaData-${code}-${metaData.id}`}
            component={RadioButton}
            type="radio"
            value="No"
            label="No"
            required={metaData.isRequired}
          />
        </>
      );
    }
    default: {
      return <div>{metaData.dataType}</div>;
    }
  }
};

const dropDownArray = (options) => {
  const optionArray = options.map((option) => ({
    value: option,
    option
  }));
  optionArray.unshift({ value: '', option: '' });
  return optionArray;
};

export default FormMetaData;
